module.exports = __webpack_public_path__ + "static/img/941B.ff69c39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/941B/941B.png
// module id = 7pvC
// module chunks = 0